import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function AccessGateModal({
  open,
  reason,
  onConfirm,
  onCancel
}) {
  const isRoleMismatch = reason === "insufficient-role";
  const title = isRoleMismatch ? "Access required" : "Login required";
  const message = isRoleMismatch ? "You’re logged in, but you don’t have the required credentials to use this feature. Please contact support to request access." : "To use this feature, you must be logged in.";
  const confirmLabel = isRoleMismatch ? "Contact support" : "Go to login";
  return /*#__PURE__*/_jsxs(Dialog, {
    open: open,
    onClose: onCancel,
    maxWidth: "xs",
    fullWidth: true,
    children: [/*#__PURE__*/_jsx(DialogTitle, {
      children: title
    }), /*#__PURE__*/_jsx(DialogContent, {
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "body2",
        color: "text.secondary",
        children: message
      })
    }), /*#__PURE__*/_jsxs(DialogActions, {
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onCancel,
        variant: "outlined",
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onConfirm,
        variant: "contained",
        children: confirmLabel
      })]
    })]
  });
}